import { formatClocks, stripTeacherFromScheduleLabel } from '@/lib/utils';

const WEEKDAY_LONG = {
  mo: 'Montag', montag: 'Montag',
  di: 'Dienstag', dienstag: 'Dienstag',
  mi: 'Mittwoch', mittwoch: 'Mittwoch',
  do: 'Donnerstag', donnerstag: 'Donnerstag',
  fr: 'Freitag', freitag: 'Freitag',
  sa: 'Samstag', samstag: 'Samstag',
  so: 'Sonntag', sonntag: 'Sonntag',
};

const WEEKDAY_SOURCE = '\\b(montag|dienstag|mittwoch|donnerstag|freitag|samstag|sonntag|mo|di|mi|do|fr|sa|so)\\.?\\b';
const TIME_RE = /\b(\d{1,2})[:.](\d{2})(?::\d{2}(?:\.\d+)?)?\b/;

function weekdayRe() {
  return new RegExp(WEEKDAY_SOURCE, 'gi');
}

function weekdayLong(token) {
  return WEEKDAY_LONG[String(token || '').toLowerCase().replace(/\./g, '')] || '';
}

function firstWeekday(text) {
  const match = String(text || '').match(weekdayRe());
  return match ? weekdayLong(match[0]) : '';
}

function firstTime(text) {
  const match = String(text || '').match(TIME_RE);
  if (!match) return '';
  return `${String(match[1]).padStart(2, '0')}:${match[2]} Uhr`;
}

/** Freitext eines Termins: große Wochentage, keine Sekunden, „Uhr“ am Ende. */
export function formatOfferSchedule(text) {
  if (text == null || text === '') return '';
  let s = formatClocks(String(text));
  s = s.replace(weekdayRe(), (token) => weekdayLong(token) || token);
  s = s.replace(/\s{2,}/g, ' ').trim();
  if (TIME_RE.test(s) && !/\bUhr\b/i.test(s)) s = `${s} Uhr`;
  return s;
}

function courseName(title, teacher, weekday, time) {
  let s = stripTeacherFromScheduleLabel(formatClocks(String(title || '')));
  s = s.replace(weekdayRe(), ' ');
  s = s.replace(new RegExp(TIME_RE.source, 'g'), ' ');
  s = s.replace(/\bUhr\b/gi, ' ');
  const drop = new Set(
    [teacher, weekday, time, time.replace(/ Uhr$/, '')]
      .filter(Boolean)
      .map((part) => part.toLowerCase()),
  );
  const pieces = s
    .split(/\s*·\s*/)
    .map((part) => part.replace(/\s*[-–,]\s*/g, ' ').replace(/\s{2,}/g, ' ').trim())
    .filter((part) => part && !drop.has(part.toLowerCase()));
  return pieces.join(' · ');
}

/**
 * Kurs · Lehrkraft · Wochentag · Uhrzeit
 * Beispiel: Klavier · Max Mustermann · Montag · 15:30 Uhr
 */
export function formatCourseOfferLine(offer) {
  const teacher = String(offer?.teacher_name || offer?.teacherName || '').trim();
  const title = String(offer?.title || '');
  const schedule = String(offer?.schedule_text || offer?.scheduleText || '');
  const source = `${title} ${schedule}`;
  const weekday = firstWeekday(source);
  const time = firstTime(source);
  const course = courseName(title, teacher, weekday, time);
  return [course, teacher, weekday, time].filter(Boolean).join(' · ');
}
